import { render } from "./MultiPublisherYieldCards.vue?vue&type=template&id=485aa578&scoped=true"
import script from "./MultiPublisherYieldCards.vue?vue&type=script&lang=js"
export * from "./MultiPublisherYieldCards.vue?vue&type=script&lang=js"

import "./MultiPublisherYieldCards.vue?vue&type=style&index=0&id=485aa578&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485aa578"]])

export default __exports__